module.exports = __webpack_public_path__ + "img/Hero@2x.deea57e4.png";